import React from 'react';

import {Heading, ListGroupItem} from '@albert-io/atomic';

import './empty-question-shell.scss';

export default function EmptyQuestionShell() {
  return (
    <div className='empty-question-shell rounded-x1 border border-solid border-border-primary background-primary'>
      <ListGroupItem>
        <Heading as='h1' size='xs' className='m-x0'>
          <span>&nbsp;</span>
        </Heading>
      </ListGroupItem>
      <div className='empty-question-shell__body p-x4' />
    </div>
  );
}
